import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PartyList from '../ContentsComponent/PartyList';
//import PropTypes from 'prop-types'
import styled from '@emotion/styled';

const PostWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4rem 4rem 1rem 4rem;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 4rem 2rem 1rem 2rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin: 4rem 1rem 1rem 1rem;
  }
`;

const SlideShow = () => {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (index === 3) { // TODO:全体の数後で調整する
        setIndex(0);
      } else {
        setIndex(prev => prev + 1);
      }
    }, 5000); //duration
    return () => clearInterval(timer); //cleanup
  }, [index]); //compare

  // filter by sub-directory name slideshow
  const RecentEventQuery = graphql`
    query {
      allContentfulFood{
        edges{
          node{
              id
            Name
            path
            price
            release
            tags{
              tag
            }
            text {
              json
            }
            mainpic{
              fluid(maxWidth:1000,quality:90){
                ...GatsbyContentfulFluid
              }
              title
            }
          }
        }
        totalCount
      }
    }
  ` 
    // pass query 
    const data  = useStaticQuery(RecentEventQuery);
    const { node } = data.allContentfulFood.edges[index];
    const { id, Name, path,price,release,tags,text,mainpic,totalCount } = node;
  return(
  <PostWrapper>
            <PartyList
              id={`$food-{id}`}
              cover={mainpic.fluid}
              path={path}
              title={Name}
              // excerpt={text.json}
              tags={tags}
              price={price}
              fadeIn="true"
            />
  </PostWrapper>
  )
}

export default SlideShow